import React from 'react';
import { Typography, Paper, Box, Divider } from '@mui/material';
import bidenImg from '../assets/Joe_Biden_presidential_portrait.jpg';
import trumpImg from '../assets/Donald_Trump_official_portrait.jpg';
import obamaImg from '../assets/President_Barack_Obama.jpg';
import bushImg from '../assets/George-W-Bush.jpeg.webp';
import clintonImg from '../assets/Bill_Clinton.jpg.webp';
import reaganImg from '../assets/Official_Portrait_of_President_Reagan_1981.jpg';
import carterImg from '../assets/JimmyCarterPortrait2.jpg';

const RifHistory = () => {
  return (
    <Paper sx={{ p: 3, mt: 3, mb: 3, maxWidth: '100%', bgcolor: 'rgba(0,0,0,0.7)' }}>
      <Box 
        sx={{ 
          height: '200px', 
          width: '100%', 
          bgcolor: '#3f51b5', 
          borderRadius: 1, 
          mb: 3,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Typography variant="h4" color="white">
          History of RIFs
        </Typography>
      </Box>
      
      <Typography variant="h4" gutterBottom align="left">
        The History of Reduction in Force in Federal Agencies
      </Typography>
      
      <Typography variant="subtitle1" gutterBottom align="left">
        Federal workforce reductions have occurred throughout modern history, often tied to administration changes and budget priorities.
      </Typography>
      
      <Divider sx={{ my: 2 }} />
      
      <Typography variant="h5" gutterBottom sx={{ mt: 3 }} align="left">
        Recent RIF Events (2000-Present)
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
        <img 
          src={bidenImg} 
          alt="President Biden" 
          style={{ width: '70px', height: '85px', marginRight: '15px', borderRadius: '4px' }} 
        />
        <Box>
          <Typography variant="h6" gutterBottom align="left">
            Biden Administration (2021-Present)
          </Typography>
          <Typography variant="body1" paragraph align="left">
            While the Biden administration has largely focused on rebuilding federal workforce capacity, some agencies have undergone targeted restructuring. The Department of Defense announced potential workforce reductions in 2022-2023 tied to modernization initiatives and shifting military priorities. However, these have generally been managed through hiring freezes and attrition rather than formal RIFs.
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
        <img 
          src={trumpImg} 
          alt="President Trump" 
          style={{ width: '70px', height: '85px', marginRight: '15px', borderRadius: '4px' }} 
        />
        <Box>
          <Typography variant="h6" gutterBottom align="left">
            Trump Administration (2017-2021)
          </Typography>
          <Typography variant="body1" paragraph align="left">
            The Trump administration implemented significant restructuring across multiple federal agencies. In 2017, then-OMB Director Mick Mulvaney issued a memorandum directing agencies to submit plans for workforce reduction and reorganization. Several agencies experienced staff reductions, including the Environmental Protection Agency, which lost nearly 1,000 employees in the first 18 months of the administration. The Department of Education and State Department also saw notable workforce decreases.
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
        <img 
          src={obamaImg} 
          alt="President Obama" 
          style={{ width: '70px', height: '85px', marginRight: '15px', borderRadius: '4px' }} 
        />
        <Box>
          <Typography variant="h6" gutterBottom align="left">
            Obama Administration (2009-2017)
          </Typography>
          <Typography variant="body1" paragraph align="left">
            While the Obama administration began with federal hiring initiatives as part of economic recovery efforts, later years saw targeted reductions. The Budget Control Act of 2011 and subsequent sequestration measures led to staffing constraints across multiple agencies. The Department of Defense conducted focused RIFs at certain installations, including a notable reduction at Joint Base Langley-Eustis in 2014 that impacted hundreds of civilian positions.
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
        <img 
          src={bushImg} 
          alt="President Bush" 
          style={{ width: '70px', height: '85px', marginRight: '15px', borderRadius: '4px' }} 
        />
        <Box>
          <Typography variant="h6" gutterBottom align="left">
            Bush Administration (2001-2009)
          </Typography>
          <Typography variant="body1" paragraph align="left">
            The George W. Bush administration oversaw significant agency restructuring, particularly following the creation of the Department of Homeland Security in 2002. This reorganization resulted in workforce shifts across 22 federal agencies. While many employees transferred to the new department, some positions were eliminated during the consolidation. The Bush administration also implemented the National Security Personnel System at DoD, which changed employment and compensation structures for many civilian employees.
          </Typography>
        </Box>
      </Box>
      
      <Divider sx={{ my: 3 }} />
      
      <Typography variant="h5" gutterBottom align="left">
        Historical RIF Events (Pre-2000)
      </Typography>
      
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
        <img 
          src={clintonImg} 
          alt="President Clinton" 
          style={{ width: '70px', height: '85px', marginRight: '15px', borderRadius: '4px' }} 
        />
        <Box>
          <Typography variant="h6" gutterBottom align="left">
            Clinton Administration (1993-2001)
          </Typography>
          <Typography variant="body1" paragraph align="left">
            The Clinton-Gore "Reinventing Government" initiative led to significant federal workforce reductions. Between 1993 and 2000, the federal workforce decreased by approximately 426,000 positions, marking the largest reduction in federal civilian employment since the post-World War II demobilization. Most of these reductions were achieved through attrition, buyouts, and early retirement incentives rather than formal RIFs.
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
        <img 
          src={reaganImg} 
          alt="President Reagan" 
          style={{ width: '70px', height: '85px', marginRight: '15px', borderRadius: '4px' }} 
        />
        <Box>
          <Typography variant="h6" gutterBottom align="left">
            Reagan Administration (1981-1989)
          </Typography>
          <Typography variant="body1" paragraph align="left">
            President Reagan implemented significant federal workforce reductions as part of his broader agenda to reduce government size. His administration pursued the "Grace Commission" recommendations and conducted substantial RIFs at agencies like the Department of Education, Environmental Protection Agency, and the Department of Housing and Urban Development. The civilian workforce at the Department of Defense also experienced notable reductions during this period.
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
        <img 
          src={carterImg} 
          alt="President Carter" 
          style={{ width: '70px', height: '85px', marginRight: '15px', borderRadius: '4px' }} 
        />
        <Box>
          <Typography variant="h6" gutterBottom align="left">
            Carter Administration (1977-1981)
          </Typography>
          <Typography variant="body1" paragraph align="left">
            Despite a reputation for government expansion, the Carter administration actually initiated the Civil Service Reform Act of 1978, which established new procedures for RIFs and performance management. This legislation created the framework for many modern federal employment practices, including structured RIF procedures that remain largely in place today.
          </Typography>
        </Box>
      </Box>
      
      <Box sx={{ mt: 4, mb: 2, fontStyle: 'italic' }}>
        <Typography variant="body2" align="left">
          Note: This article provides a general historical overview. Specific RIF events may have varied in scope and implementation across agencies. For official information about RIF procedures and policies, consult OPM guidance.
        </Typography>
      </Box>
    </Paper>
  );
};

export default RifHistory; 